<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin],
  data() {
    return { };
  },
  methods: {
    isItemActive(item) {
      const re = new RegExp(`^(${item.matching_name})$`);
      const resp = re.test(globalState.pageModel.main_content_name);
      return resp;
    },
    getItemUrl(item) {
      if(this.content.preserve_url_params) {
        return item.url.url + '?' + window.location.search.substr(1);
      } else {
        const anchor = item.url.url.split("#")[1];
        if (anchor) {
          return `#${anchor}`;
        } else {
          return item.url.url;
        }
      }
    },
    itemClasses(item) {
      let classes = [];
      if (this.isItemActive(item)) {
        classes.push(`bg-${this.color}`);
        classes.push('link-white');
      } else {
        classes.push('link-black');
      }
      return classes;
    }
  },
  computed: {
    contentClasses() {
      let classes = [this.contentType];
      if (this.content.sticky || this.sticky) {
        classes.push('sticky-top');
      }
      return classes;
    },
    activeItem() {
      const title = get(this.pageModel, ["seo", "title"], "");
      return title ? title.split('|')[0] : '';
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="[contentClasses]" navbar-secondary-component>
    <nav class="navbar navbar-expand-md d-flex justify-content-between" id="secondary-nav">
      <div class="active-item d-flex align-items-center nav-item">{{activeItem}}</div>
      <button class="navbar-toggler shadow-none border-0 collapsed" type="button" data-toggle="collapse" data-target="#secondaryNavbar">
        <i class="fal fa-chevron-up"></i>
      </button>
      <div class="collapse navbar-collapse" id="secondaryNavbar">
        <div class="navbar-nav mx-auto">
          <li class="nav-item mr-3" v-for="item in content.items" :class="{'active': isItemActive(item)}">
            <a 
              class="nav-link px-3 py-2 pl-0" 
              :class="itemClasses(item)" 
              :href="getItemUrl(item)"
            >{{item.url.title}}</a>
          </li>
        </div>
      </div>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
[navbar-secondary-component] {

  $secondary-navbar-height: 5rem;
  font-size: .75rem !important; 
  font-transform: capitalize;
  font-weight: 600;

  .nav-item {
    text-transform: uppercase;
    font-size: .75rem !important;

    a {
      text-decoration: none;
      transition: color .25s;
      font-weight: 500;
    }

    @include media-breakpoint-down(sm) {
      &.active {
        display: none;
      }
    }
  }

  .navbar-toggler {
    font-size: .875rem;
    transition: transform .25s;
    height: 4rem;

    &:focus {
      outline: 0px;
    }

    &.collapsed {
      transform: rotate(180deg);
    }
  }

  @include media-breakpoint-up(md) {
    #secondary-nav {
      height: $secondary-navbar-height;
    }

    .active-item {
      display: none !important;
    }
  }
}
</style>